module.exports = __webpack_public_path__ + "img/pay-logo-visa.fa5fbad4.svg";